/**
 * Resolves an asset path (e.g. from an API response or a static reference)
 * to a full URL using Vite's BASE_URL.
 *
 * Handles:
 * - Absolute paths (`/assets/icons/salesforce.svg`) → prefixed with BASE_URL
 * - Full URLs (`https://...`) → returned as-is
 * - Already-resolved paths → returned as-is (idempotent)
 */
export function resolveAssetUrl(path: string): string {
  if (path.startsWith('http')) {
    return path;
  }
  // Rewrite /assets/icons/ to /hydra-assets/icons/ so CDP icon paths
  // from API responses don't collide with the /assets/ vite proxy.
  const rewritten = path.replace(/^\/assets\/icons\//, '/hydra-assets/icons/');
  const baseUrl = (import.meta.env.BASE_URL ?? '').replace(/\/$/, '');
  if (baseUrl.length > 0 && rewritten.startsWith(`${baseUrl}/`)) {
    return rewritten;
  }
  return `${baseUrl}${rewritten.startsWith('/') ? '' : '/'}${rewritten}`;
}
